<template lang="html">

  <div data="documentacion" class="cv-part">

    <h2 class="title" @click="openedit">Intereses</h2>
    <p>Envio proactivo de tu CV: <span>{{(busqueda_activa) ? 'Sí':'No'}}</span></p>
    <p>Intereses profesionales: 
      <span v-if="!!intereses">{{intereses[0].nombre}}</span>
      <span v-else>Sin intereses añadidos</span>
    </p>

    <div class="cover-popup row-center" v-if="showedit">
      <div class="popup">

        <a class="close" @click="showedit = false">✕</a>
        <h2 class="title-pop">Editar intereses</h2>

        <div class="toggle-checkbox row-start -with-popup-info" :edit="showedit">
          <input type="checkbox" id="envioproactivocv" v-model="busqueda_activaedit" @change="editEnvioProactivoCV(busqueda_activaedit)">
          <label for="envioproactivocv">Envio proactivo de tu CV</label>
          <popupinfo :id="'envio-proactivo'"></popupinfo>
        </div>

        <div class="textarea">
          <label for="interesesprofesionales">Intereses profesionales <popupinfo :id="'informacion-interes'"></popupinfo></label>
          
          <textarea v-validate="'max:150'" v-model="interesesedit" name="interesesprofesionales" id="interesesprofesionales" placeholder="Puestos, áreas funcionales y sectores de tu interés, y notas para el equipo UDP."></textarea>
          <span class="error" :warning="interesesedit.length >= 140 && interesesedit.length <= 150" v-if="interesesedit.length >= 140">Longitud maxima {{interesesedit.length}}/150</span>
        </div>

        <button class="btn" @click="senddata" :loading="loading" v-if="interesesedit.length <= 150">Guardar</button>
      </div>
    </div>

  </div>

</template>

<script lang="js">
  
  import {mapActions} from 'vuex';


  import popupinfo from '@/components/parts/popup-info';

  export default {
    name: 'intereses',
    props: ['busqueda_activa','intereses'],
    mounted(){
      (!!this.intereses) ? this.interesesedit = this.intereses[0].nombre : null;
      this.busqueda_activaedit = this.busqueda_activa;
    },  
    data() {
      return {
        showedit: false,
        interesesedit : '',
        busqueda_activaedit : false,
        loading : false
      }
    },
    methods :{
      ...mapActions(['editInteresesProfesionales','editEnvioProactivoCV','canEditCv']),
      senddata(){
        this.loading = true;
        if(this.interesesedit.length <= 150){
          this.editInteresesProfesionales(this.interesesedit).then(r =>{
            this.showedit = false;
            this.loading = false;
          });
        }
      },
      openedit(){
        this.canEditCv().then(r =>{
          (r) ? this.showedit = true : '';
        });
      }
    },
    components : {
      'popupinfo' : popupinfo
    }
  }
</script>

<style scoped lang="scss">
</style>


// WEBPACK FOOTER //
// src/components/views/mi-cv/intereses.vue